import UserProfile from "@/domain/entities/user/UserProfile";
import { queryKeys } from "@/lib/queryKeys";
import { userToDomainMapper } from "@/mappers/user/userMapper";
import { useServiceContext } from "@cs_teamwaydev/mailvista-sdk_react";
import { useQuery, UseQueryResult } from "@tanstack/react-query";
import useFetchErrorNotifier from "./utils/useFetchErrorNotifier";

const useGetUserProfile = (): UseQueryResult<
    UserProfile | undefined,
    Error
> => {
    const userManager = useServiceContext().sdk?.userManager;
    const notifyFetchError = useFetchErrorNotifier();

    const fetchUser = async () => {
        if (!userManager) {
            throw new Error("UserManager is undefined");
        }

        try {
            return userToDomainMapper(await userManager.getUserProfile());
        } catch (error) {
            console.error(error);
            notifyFetchError({
                queryKey: queryKeys.user.profile(),
                titleTranslationKey: "errors.global.title",
            });

            // Sans le throw, TanStack rejette sur « data is undefined » et perd la cause.
            throw error;
        }
    };

    const userProfile = useQuery({
        queryKey: queryKeys.user.profile(),
        queryFn: fetchUser,
    });

    return userProfile;
};

export default useGetUserProfile;
